import { css } from '@emotion/core';
import { MediaQueries } from '../../../../styles/Grid';
import { colorsPalette } from '../../../../styles/colors';
import { typography, fontWeights } from '../../../../styles/typography';

export const hero = css({
  marginBottom: 32,
  marginTop: 16,
  [MediaQueries.mdAndUp]: {
    marginBottom: 48,
    marginTop: 24,
  },
});

export const headline = css(typography.effra22, {
  fontWeight: fontWeights.medium,
  margin: 0,
  [MediaQueries.mdAndUp]: {
    ...typography.effra40,
    fontWeight: fontWeights.medium,
  },
});

export const subHeadline = css({
  marginTop: 8,
  [MediaQueries.mdAndUp]: {
    marginTop: 16,
  },
});

export const subHeadlineCopy = css(typography.effra16, {
  [MediaQueries.mdAndUp]: {
    ...typography.effra18,
  },
});

export const contactInformation = css({
  display: 'none',
  [MediaQueries.lgAndUp]: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'flex-end',
  },
});

export const contactInformationThumbnailWrapper = css({
  backgroundColor: colorsPalette.grey10,
  borderRadius: '50%',
  flex: '0 0 48px',
  height: 48,
  marginRight: 16,
  overflow: 'hidden',
  width: 48,
});

export const contactInformationThumbnail = css({
  display: 'block',
  width: '100%',
});

export const contactInformationContactInfo = css({
  maxWidth: 280,
});

export const contactInformationCopy = css(typography.effra16, {
  color: colorsPalette.teal,
  fontWeight: fontWeights.medium,
});

export const contactInformationNumber = css(typography.effra16, {
  color: colorsPalette.black,
  textDecoration: 'none',
  ':focus, :hover': {
    textDecoration: 'underline',
  },
});
